import 'what-input';

import { accordion } from './accordion';
import { calcHeight } from './calcHeight';
import { changeHeader } from './changeHeader';
import { changeMetaViewport } from './changeMetaViewport';
import { drawerMenu } from './drawerMenu';
import { fixedHeader } from './fixedHeader';
import { hamburgerMenu } from './hamburgerMenu';
import { hashScroll } from './hashScroll';
import { hoverImage } from './hoverImage';
import { popupBanner } from './popupBanner';
import { showBanner } from './showBanner';
import { slider } from './slider';
import { transitionClass } from './transitionClass';

// import '../scss/style.scss';
// import '../scss/editor.scss';

accordion();
calcHeight();
changeHeader();
changeMetaViewport();
drawerMenu();
fixedHeader();
hamburgerMenu();
hashScroll();
hoverImage();
popupBanner();
showBanner();
slider();
transitionClass();
